import { memo } from 'react';
import type { ComponentType } from 'react';
import { Check, X } from 'lucide-react';

import { cn } from '../../../lib/cn';

interface BooleanCellProps {
  value: boolean | null | undefined;
  trueLabel?: string;
  falseLabel?: string;
  trueIcon?: ComponentType<{ className?: string }>;
  falseIcon?: ComponentType<{ className?: string }>;
  className?: string;
}

export const BooleanCell = memo(function BooleanCell({
  value,
  trueLabel,
  falseLabel,
  trueIcon: TrueIcon = Check,
  falseIcon: FalseIcon = X,
  className,
}: BooleanCellProps) {
  if (value === null || value === undefined) {
    return <span className="text-slate-400">-</span>;
  }

  if (value) {
    return (
      <span className={cn('inline-flex items-center gap-1 text-green-600', className)}>
        <TrueIcon className="h-4 w-4" />
        {trueLabel && <span className="text-xs">{trueLabel}</span>}
      </span>
    );
  }

  return (
    <span className={cn('inline-flex items-center gap-1 text-red-500', className)}>
      <FalseIcon className="h-4 w-4" />
      {falseLabel && <span className="text-xs">{falseLabel}</span>}
    </span>
  );
});
